export enum DocumentProcessStatus {
    Pending,
    Signed,
    Declined,
    Received
}

export const DocumentProcessStatusTranslate = new Map<number, string>([
    [DocumentProcessStatus.Pending, "documentProcessStatus.Pending"],
    [DocumentProcessStatus.Signed, "documentProcessStatus.Signed"],
    [DocumentProcessStatus.Declined, "documentProcessStatus.Declined"],
    [DocumentProcessStatus.Received, "documentProcessStatus.Received"],
]);